import { ComponentCategory, ComponentType } from '../../types';

export default {
  name: ComponentType.TabPane,
  title: 'Tab Pane',
  category: ComponentCategory.Layout,
  droppable: true,
  showInLibrary: false,
};
